export const DEFAULT_FILTERS = {
  search: '',
  category: '',
  brand: '',
  shape_id: '',
  class_id: '',
  priceRange: [0, 1000] as [number, number],
  order_by: 'discount'
}

export const ITEMS_PER_PAGE = 12

export const DEFAULT_PAGE_SIZE = 12
export const PAGE_SIZE_WITHOUT_FILTERS = 20

export const VISUALIZATION_MODE_OPTIONS = [
  {
    id: 1,
    title: 'Em lista',
    type: 'list'
  },
  {
    id: 2,
    title: 'Em grade',
    type: 'grid'
  }
]

export const LAYOUT_SELECT_OPTIONS = VISUALIZATION_MODE_OPTIONS.map((option) => ({
  value: option.type,
  label: option.title
}))

export const DISPLAY_OPTIONS = [
  { title: 'Em Grid', type: 'grid' },
  { title: 'Em Lista', type: 'list' }
] as const


export const FILTER_ORDER_OPTIONS = [
  {
    id: 1,
    title: 'Relevância',
    type: 'relevance'
  },
  {
    id: 2,
    title: 'Mais vendidos',
    order: 'DESC',
    type: 'bestseller'
  },
  {
    id: 3,
    title: 'Menor preço',
    order: 'ASC',
    type: 'price'
  },
  {
    id: 4,
    title: 'Maior preço',
    order: 'DESC',
    type: 'price'
  }
]

export const ORDER_SELECT_OPTIONS = FILTER_ORDER_OPTIONS.map((option) => ({
  value: option.order ? `${option.type}-${option.order}` : option.type,
  label: option.title
}))


export const RELEVANCE_ORDER_BY = 'relevance'

export const BESTSELLER_ORDER_BY = 'bestseller'
export const BESTSELLER_ORDER_DIR = 'DESC'


export const PRICE_ORDER_BY = 'price'
export const PRICE_ORDER_DIR = 'ASC'

export const FLOWER_ANNOUNCEMENT_KEY = 'flower-accept'
export const FLOWER_SHAPE_ID = '29'
export const SUPPLEMENT_CLASS_ID = 6

export const FREE_SHIPPING_THRESHOLD = 2500
export const NATIONAL_SUPPLIER_ID = 18
